var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppStoreLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 18,
    height: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.873 0H5.12695C2.29995 0 0 2.29995 0 5.12695V19.873C0 22.7 2.29995 25 5.12695 25H19.873C22.7 25 25 22.7 25 19.873V5.12695C25 2.29995 22.7 0 19.873 0ZM13.2169 4.94551C14.3334 3.47397 15.8855 3.4668 15.8855 3.4668C15.8855 3.4668 16.1164 4.85024 15.0073 6.18301C13.823 7.6061 12.4769 7.37319 12.4769 7.37319C12.4769 7.37319 12.2241 6.254 13.2169 4.94551ZM15.6645 20.434C14.6717 20.434 13.8999 19.765 12.8539 19.765C11.7879 19.765 10.73 20.459 10.0411 20.459C8.06733 20.459 5.57378 16.1863 5.57378 12.7519C5.57378 9.37275 7.68442 7.60015 9.66416 7.60015C10.9511 7.60015 11.9499 8.34233 12.6189 8.34233C13.1933 8.34233 14.2592 7.55283 15.6468 7.55283C18.0352 7.55283 18.9748 9.25234 18.9748 9.25234C18.9748 9.25234 17.1371 10.1919 17.1371 12.4717C17.1371 15.0435 19.4263 15.9298 19.4263 15.9298C19.4263 15.9298 17.826 20.434 15.6645 20.434Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreLight);
export default __webpack_public_path__ + "static/media/AppStoreLight.992dc4411831acd77912f6c47d2ff813.svg";
export { ForwardRef as ReactComponent };